export default __webpack_public_path__ + "static/media/424.0c2357f7.jpg";